module.exports = __webpack_public_path__ + "static/media/DSC_0058 (2).2bcffd34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0058 (2).jpg
// module id = 683
// module chunks = 0